import { ReportTableColumn } from '../models/report-table-column.model';

export const ProductUsageTable: ReportTableColumn[] = [
  {
    displayName: 'Product #',
    columnName: 'product-number',
    propertyName: 'Product Number',
    width: 'narrow',
  },
  {
    displayName: 'Product Description',
    columnName: 'product-description',
    propertyName: 'Product Description',
    width: 'wide',
  },
  {
    displayName: 'Brand',
    columnName: 'brand',
    propertyName: 'Brand',
    width: 'medium',
  },
  {
    displayName: 'Pack',
    columnName: 'pack',
    propertyName: 'Pack',
    width: 'narrow',
  },
  {
    displayName: 'Manufacturer Name',
    columnName: 'manufacturer-name',
    propertyName: 'Manufacturer Name',
    width: 'wide',
  },
  {
    displayName: 'Manufacturer Product #',
    columnName: 'manufacturer-product-number',
    propertyName: 'Manufacturer Product Number',
    width: 'narrow',
  },
  {
    displayName: 'Net Weight Shipped',
    columnName: 'net-weight-shipped',
    propertyName: 'Net Wght Shipped',
    width: 'medium',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Cases',
    columnName: 'cases',
    propertyName: 'Cases',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Dollars',
    columnName: 'dollars',
    propertyName: 'Dollars',
    width: 'narrow',
    format: 'currency',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: '% Case Purchase',
    columnName: 'percent-case-purchase',
    propertyName: '% Case Purchase',
    width: 'narrow',
    format: 'percent',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: '% Dollar Purchase',
    columnName: 'percent-dollar-purchase',
    propertyName: '% $ Purchase',
    width: 'narrow',
    format: 'percent',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Avg$/CS',
    columnName: 'avg-dollar-per-case',
    propertyName: 'Avg$/CS',
    width: 'narrow',
    format: 'currency',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
];
